import React, {memo} from "react";
import {useTranslation} from "react-i18next";
import Table from "../../../Lib/Table/Table";
import {useCompetitions} from "../../../Api/competitions";
import ContentBox from "../../../Components/ContentBox/ContentBox";
import DefaultActions from "../../../Lib/Table/DefaultActions";

const urlNs = "/admin/competitions/";

const List = memo((props) => {

  const {path} = props;

  const {t} = useTranslation('competition');

  const { data } = useCompetitions();

  const columns = [
    {
      accessor: 'id',
      Header: t('general:identifier')
    },
    {
      accessor: 'name',
      Header: t('general:name')
    },
    {
      accessor: 'mnemonic',
      Header: t('mnemonic')
    },
    {
      accessor: 'year',
      Header: t('year')
    },
    {
      accessor: 'climbingTypes',
      Header: t('climbingTypes')
    },
    {
      accessor: 'status',
      Header: t('general:status')
    },
    {
      accessor: 'actions',
      Header: t('general:actions'),
      Cell: ({row}) => <DefaultActions urlNs={urlNs} id={row.values.id} hideDelete/>
    }
  ];

  return (
      <ContentBox path={path} add={urlNs + "add"}>
        <Table columns={columns} data={data} />
      </ContentBox>
  );
});

export default List;